import { render, staticRenderFns } from "./cabinet-requests-list-new-item.vue?vue&type=template&id=2bbf1eee&scoped=true"
import script from "./cabinet-requests-list-new-item.vue?vue&type=script&lang=js"
export * from "./cabinet-requests-list-new-item.vue?vue&type=script&lang=js"
import style0 from "./cabinet-requests-list-new-item.vue?vue&type=style&index=0&id=2bbf1eee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf1eee",
  null
  
)

export default component.exports